import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { NavigationMenuLinks } from "@/components/NavigationMenu";
import ComparisonDatabase from "@/components/Review/ComparisonDatabase";
import SectorComparison from "@/components/Review/SectorComparison";

import { useReviewContext } from "./Review";

export const handle = {
  activeMenuLink: NavigationMenuLinks.restitution,
  breadcrumb: ({ reviewId }: { reviewId: string }) => {
    return [
      {
        href: `/reviews/${reviewId}/comparaison`,
        label: "review:comparison:sectoralComparison",
      },
    ];
  },
};

function ReviewComparison() {
  const { reviewData, industryData } = useReviewContext();
  const { t, i18n } = useTranslation(["common", "formatter", "review"]);

  if (!reviewData || !industryData) {
    return (
      <div className="grid place-items-center">
        <p>{t("common:loading")}</p>
      </div>
    );
  }

  const {
    carbon,
    employees,
    turnover,
    period_start: periodStart,
    period_end: periodEnd,
  } = reviewData;

  const { title_en, title_fr, comparison } = industryData;

  return (
    <>
      <Typography step="3" as="h1" weight="bold" className="mb-3xs">
        {t("review:comparison.sectoralComparison")}
      </Typography>
      <Typography className="text-grayscale-dark">
        {t("formatter:date", { value: new Date(periodStart) })}
        &nbsp;-&nbsp;
        {t("formatter:date", { value: new Date(periodEnd) })}
      </Typography>
      <div className="my-md gap-y-sm lg:gap-md grid xl:grid-cols-[1fr_3fr]">
        <div className="xl:order-last">
          <SectorComparison
            carbon={carbon}
            employees={employees}
            turnover={turnover}
            comparison={comparison}
          />
        </div>
        <ComparisonDatabase
          title={i18n.language === "en" ? title_en : title_fr}
          comparison={comparison}
        />
      </div>
    </>
  );
}

export default ReviewComparison;
